var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"p-4 text-center",attrs:{"color":"#f6f9fc","flat":"","height":_vm.height}},[(_vm.title)?_c('v-card-title',[_c('h2',[_vm._t("header")],2)]):_vm._e(),_c('v-card-text',[_vm._t("body")],2),(_vm.actions)?_c('v-card-actions',[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }